import { lightTheme as baseTheme } from '@zenbusiness/zui/styles';

export const cardIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACdSURBVHgB7ZRLDoQgDIb/Gtl7BG82bGA/N3Bu4BpWczI9gicAywJDoivBqAlfwqM09JE2BSp3Q/Gitf4450Yi6pDHzDYGY8w/CE189d4PBYwHerY1RqFNFWGz1hIyUEp5PrZAG1xMi+MIinF5Bu93sKtBoS7aqDV4oAMpZY+THP1Nu2jh1QkhJu4E5MBDc473NINvqshg4Wn6Q+UxrFE7JwXy9/IJAAAAAElFTkSuQmCC';

export const classes = {
  empty: 'field--empty',
  valid: 'field--valid',
  invalid: 'field--invalid',
  focused: 'field--focused',
  dirty: 'field--dirty',
  touched: 'field--touched'
};

const BaseCss = {
  position: 'relative',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '28px',
  padding: '0 16px',
  boxSizing: 'border-box',
  border: 'none',
  maxWidth: '100%',

  color: baseTheme.palette.text.primary,
  '@font-face': {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontDisplay: 'swap',
    src: 'url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format("woff2")',
    unicodeRange:
      'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
  }
};

const styleBorder = ({ theme, isError }) => {
  if (isError) {
    return {
      border: `1px solid ${theme.palette.error.main}!important`
    };
  }
  return { border: `1px solid ${theme.palette.border.main}` };
};

export const LabelStyle = ({ theme, isError }) => {
  if (isError) {
    return {
      color: `${theme.palette.text.red}!important`
    };
  }
  return {};
};

export const VGSInputStyle = ({ theme, isError }) => ({
  height: '56px',
  ...styleBorder({ theme, isError }),
  borderRadius: '16px',

  '&.field--focused': {
    borderColor: `${baseTheme.palette.border.main}!important`
  },
  '&.field--invalid.field--touched:not(.field--empty)': {
    borderColor: baseTheme.palette.error.main
  },
  [theme.breakpoints.up('sm')]: {
    height: '64px'
  }
});

export const GenerateInputCSS = (isMobile) => ({
  ...BaseCss,
  height: isMobile ? '56px' : '64px',
  fontSize: isMobile ? '18px' : '22px',
  '&::placeholder': {
    color: `${baseTheme.palette.text.secondary}`
  }
});

export const GenerateSelectCSS = (isMobile) => ({
  ...BaseCss,
  height: isMobile ? '56px' : '64px',
  fontSize: isMobile ? '18px' : '22px',

  '&::placeholder': {
    color: `${baseTheme.palette.text.secondary}`
  },
  appearance: 'none',

  backgroundRepeat: 'no-repeat',

  backgroundImage: [
    'linear-gradient(45deg, transparent 50%, gray 50%)',
    'linear-gradient(135deg, gray 50%, transparent 50%)'
  ].join(','),
  backgroundPosition: [
    'calc(100% - 20px) calc(1em + 5px)',
    'calc(100% - 15px) calc(1em + 5px)'
  ].join(','),
  backgroundSize: ['5px 5px', '5px 5px'].join(',')
});
